import { createSelector } from "@reduxjs/toolkit";
import { Store } from "./last-action.store";
const getLastActionFeature = (state) => state[Store.featureKey];
export const getLastAction = createSelector(getLastActionFeature, ({ actionType: action }) => action);
export const isLastAction = (targetAction) => createSelector(getLastAction, (actionType) => actionType === targetAction.type ? true : undefined);
